var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","position":"absolute","top":"0px","z-index":"100"}},[_c('photo-slider',{ref:"slider",staticStyle:{"width":"100%","height":"100%","position":"absolute","top":"0px","z-index":"100"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }